import { typeArticleGroup } from "./articleGroup"
import { queryArticleGroups } from "./queries/queryArticleGroups"

const articleGroupSchema = {
  types: [typeArticleGroup],
  resolvers: {
    Query: {
      ...queryArticleGroups,
    },
    Mutation: {},
  },
}

export default articleGroupSchema
